import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type ModelType = {
	id: string;
	tenant_id: Buffer;
	name: string;
	type: string;
	definition: string;
	inserted_at: string;
	updated_at: string;
}

export type State = {
	items: ModelType[]
};

export const INITIAL_STATE: State = {
	items: []
};

const slice = createSlice({
	name: 'reportConfiguration',
	initialState: INITIAL_STATE,
	reducers: {
		fetchReportConfiguration: state => {
			state.items = [];
		},
		fetchReportConfigurationSuccess: (state, action: PayloadAction<ModelType[]>) => {
			state.items = [...action.payload];
		},
		fetchReportConfigurationError: state => {
			state.items = [];
		},
		removeConfiguration: () => {
			// TODO: change it whenever we have a real implementation
		}
	}
});

export const { fetchReportConfiguration, fetchReportConfigurationSuccess, fetchReportConfigurationError, removeConfiguration } = slice.actions;

export default slice.reducer;
